import React, { createContext, useReducer } from 'react';
import { userReducer } from './userReducer';
export const UserContext = createContext();
const initialState = {
    usuarios: [],
    page: 'list',
    clientes: [],
    agentes: [],
    dsTras: { stats: 0, trend: 0, total: 0, data: [] },
    dsInstall: { stats: 0, trend: 0, total: 0, data: [] },
    dsTks: { stats: 0, trend: 0, total: 0, data: [] },
    trafico: { days: [], down: [], up: [] },
    dashboard: { clientes: 0, cliOnline: 0, pagos: [], promisePays: [], olts: [] },
    resFin: [],
    chargebacks: [],
    resumen: {},
    ds: {},
    idemploye: null,
    permisos: 0,
};
export const UsersProvider = ({ children }) => {
    const [usersState, dispatchUs] = useReducer(userReducer, initialState);
    return (
        <UserContext.Provider
            value={{
                usersState,
                dispatchUs,
            }}>
            {children}
        </UserContext.Provider>
    );
};
